module.exports = __webpack_public_path__ + "img/gutmicrobiomeInfo.a8d7081a.png";